import dayjs from 'dayjs';
export const startDate = (num, day) => {
    day = day ? day : new Date();
    return dayjs(day).startOf('day').subtract(num, 'day').format('YYYY-MM-DD HH:mm:ss');
}
export const endDate = (num, day) => {
    day = day ? day : new Date();
    return dayjs(day).endOf('day').subtract(num, 'day').format('YYYY-MM-DD HH:mm:ss');
}
export const pickerOptions = {
    shortcuts: [
        {
            text: "今天",
            onClick(picker) {
                const start = startDate(0);
                const end = endDate(0);
                picker.$emit("pick", [start, end]);
            },
        },
        {
            text: "昨天",
            onClick(picker) {
                const start = startDate(1);
                const end = endDate(1);
                picker.$emit("pick", [start, end]);
            },
        },
        {
            text: "近3天",
            onClick(picker) {
                const start = startDate(2);
                const end = endDate(0);
                picker.$emit("pick", [start, end]);
            },
        },
        {
            text: "最近一周",
            onClick(picker) {
                const start = startDate(6);
                const end = endDate(0);
                picker.$emit("pick", [start, end]);
            },
        },
        {
            text: "最近一个月",
            onClick(picker) {
                const start = startDate(29);
                const end = endDate(0);
                picker.$emit("pick", [start, end]);
            },
        },
        {
            text: "最近三个月",
            onClick(picker) {
                const start = startDate(89);
                const end = endDate(0);
                picker.$emit("pick", [start, end]);
            },
        },
    ],
}
